import { Center, Container, Spinner, Text } from '@chakra-ui/react';
import { EnrollmentLeadForm } from './EnrollmentLeadForm';
import { EnrollmentPage } from './EnrollmentPage';
import { useSettings } from '../../hooks/useSettings';

export const EnrollmentGate = () => {
  const [settings, settingsLoading] = useSettings();
  const bannerText = settings?.bannerOptions?.text ?? '';
  const showBanner = settings?.bannerOptions?.visible && Boolean(bannerText);
  const enrollmentAvailable = settings?.enrollmentAvailable ?? true;

  if (settingsLoading) {
    return (
      <Center py={12}>
        <Spinner size="lg" color="orange.500" aria-label="Ładowanie" />
      </Center>
    );
  }

  if (enrollmentAvailable) {
    return <EnrollmentPage />;
  }

  return (
    <>
      {showBanner && (
        <Text
          fontSize={{ base: 'xs', sm: 'sm', md: 'lg' }}
          fontWeight="semibold"
          textTransform="uppercase"
          letterSpacing="wider"
          lineHeight="1.2"
          textAlign="center"
          color="gray.600"
          pt={{ base: 4, md: 6 }}
          whiteSpace="normal"
        >
          {bannerText}
        </Text>
      )}

      <Container maxW="lg" py={{ base: 6, md: 10 }}>
        <EnrollmentLeadForm variant="plain" />
      </Container>
    </>
  );
};

export default EnrollmentGate;
